import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

const billingReportRoutes: Routes = [];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(billingReportRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class BillingReportRoutingModule {}
